import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=00b7b734&scoped=true&"
import script from "./sidemenu.vue?vue&type=script&lang=js&"
export * from "./sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sidemenu.vue?vue&type=style&index=1&id=00b7b734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7b734",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer})
